'use strict';

function halloween () {
  var moment = window.moment;
  if (typeof moment === 'undefined' || typeof moment.range === 'undefined') {
    return;
  }
  var startDate = new Date(2015, 9, 29);
  var endDate = new Date(2015, 10, 2);
  var period = moment.range(startDate, endDate);
  var isInHalloweenPeroid = period.contains(new Date());
  var $logo = $('#top .navbar-brand');
  var canTrigger = true;

  if (!isInHalloweenPeroid) {
    return;
  }

  $logo.addClass('halloween');

  function batThrower (event) {
    var number = Math.max(Math.floor(Math.random() * 15), 5);
    for (var i = 0; i < number; i++) {
      var delay = Math.floor(Math.random() * 500);
      setTimeout(function () {
        var particule = new Particule(event);
        particule.generate();
      }, delay);
    }
  }

  var Particule = function (event) {
    this.diag = Math.sqrt(Math.pow(window.innerHeight, 2) + Math.pow(window.innerWidth, 2));
    this.origin = {
      x: event.clientX,
      y: event.clientY
    };
    this.end = {
      directionX: Math.round((Math.random() * 2) - 1) || 1
    };
    this.end.x = Math.floor(Math.random() * this.diag) * this.end.directionX;
    this.end.y = Math.floor(Math.random() * this.diag);
    this.element = document.createElement('div');
  };

  Particule.prototype.generate = function () {
    var $div = $(this.element).clone();
    var angle = (180 / Math.PI) * Math.atan2(this.end.y, this.end.x) + 90;
    var scale = 'scale(0.25)';
    var rotate = 'rotate(' + angle + 'deg)';
    var translate = 'translate(0,0)';
    var transform = [translate, scale, rotate].join(' ');
    this.rotate = rotate;
    $div.addClass('halloween-particule').css({
      'top': this.origin.y - 10,
      'left': this.origin.x - 32,
      'visibility': 'hidden',
      'transform': transform
    });
    $('body').append($div);
    this.animate($div);
  };

  Particule.prototype.animate = function ($div) {
    var translate = 'translate(' + this.end.x + 'px,' + this.end.y + 'px)';
    var scale = 'scale(' + Math.random() * 1 + ')';
    var speed = 100;
    var dist = Math.sqrt(Math.pow(this.end.x, 2) + Math.pow(this.end.y, 2));
    var time = dist / speed;
    var timeRandom = Math.max(Math.random() * (dist / speed), time);
    var transform = [translate, scale, this.rotate].join(' ');
    setTimeout(function () {
      $div.css({
        'visibility': 'visible',
        'transform': transform,
        'transition': 'transform ' + timeRandom + 's  cubic-bezier(0,0.5,0.5,1)'
      });
    }, 10);
    $div.fadeOut(timeRandom * 1000, function () {
      $(this).remove();
    });
  };

  $logo.on('mouseenter', function (event) {
    if (canTrigger === true) {
      canTrigger = false;
      batThrower(event);
      setTimeout(function () { canTrigger = true; }, 1000);
    }
  });
}

module.exports = halloween;
